import { Injectable } from '@angular/core';
import { HttpClientModule, HttpClient, HttpHeaders, HttpHeaderResponse, HttpRequest } from '@angular/common/http';
//import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs';
// import 'rxjs/add/operator/map';
import { map ,delay} from 'rxjs/operators';

import { AppGlobals } from '../shared/app.global';

@Injectable({
  providedIn: 'root'
})
export class PlacementService {

  callurl: string = '';
  
    clcd:string;
    aycd:string;
    usid:string;
    insid:string;
    
        constructor(private http: HttpClient,private _global: AppGlobals) {
    
           this.clcd=localStorage.getItem('clcd');
           this.aycd=localStorage.getItem('aycd');
           this.usid=localStorage.getItem('usid');
           this.insid=localStorage.getItem('masclid');
         
           this.callurl=_global.baseAPIUrl;
         }

getcurenttime()
{
    debugger
    let timenow= new Date().toString().split(' ')[4];
    return timenow;
}
         getdatetoday()
         {
          let d: Date = new Date();
          var mnth;
          var day='';
          //let todayDate = {year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate()};
          if(d.getMonth()>=9)
          {
            mnth=d.getMonth()+1;
          }
          else{
           // mnth='0'+d.getMonth()+1;
           mnth=d.getMonth()+1;
           mnth='0'+mnth;
          }
       
          if(d.getDate()>=10)
          {
            day=d.getDate().toString();
          }
          else{
            day='0'+d.getDate();
          }
          let todayDate =  d.getFullYear()+'-'+ mnth+'-' +day;
            
       return todayDate;
       
         }

         getcandidates(inid,status): Observable<any> {
          debugger
        
          return this.http.get(this.callurl + 'getcandidates/'+inid+'/'+status)
          .pipe(map((data: any) => {
                  console.log('retres-data', data);
                  return data.canlist;
                  
              }));
        }

        getcandidatesum(inid): Observable<any> {
          debugger
        
          return this.http.get(this.callurl + 'getcandidatesum/'+inid)
          .pipe(map((data: any) => {
                  console.log('retres-data', data);
                  return data.canlist;
                  
              }));
        }

        getcandidinfocnt(inid): Observable<any> {
          debugger
        
          return this.http.get(this.callurl + 'candidinfocnt/'+this.clcd+'/'+this.aycd+'/'+inid)
          .pipe(map((data: any) => {
                  console.log('retres-data', data);
                  return data;
                  
              }));
        }

        updateplacement(inid,status,stuid): Observable<any> {
          debugger
        
          return this.http.get(this.callurl + 'updateplacement/'+inid+'/'+status+'/'+stuid)
          .pipe(map((data: any) => {
                  console.log('retres-data', data);
                  return data;
                  
              }));
        }


        updateplacementsel(jpid,inid,stuid,status): Observable<any> {
          debugger
        
          return this.http.get(this.callurl + 'updateplacementsel/'+jpid+'/'+inid+'/'+stuid+'/'+status)
          .pipe(map((data: any) => {
                  console.log('retres-data', data);
                  return data;
                  
              }));
        }
        getinstitute(): Observable<any> {
          debugger
        
          return this.http.get(this.callurl + 'getinstitutes/'+this.clcd+'/'+this.aycd)
          .pipe(map((data: any) => {
                  console.log('retres-data', data);
                  return data.inslist;
                  
              }));
        }

        getcompanies(): Observable<any> {
          debugger
        
          return this.http.get(this.callurl + 'getcompanies/'+this.clcd+'/'+this.aycd)
          .pipe(map((data: any) => {
                  console.log('retres-data', data);
                  return data.complist;
                  
              }));
        }

        getjobposts(): Observable<any> {
          debugger
        
          return this.http.get(this.callurl + 'getjobposts/'+this.clcd+'/'+this.aycd)
          .pipe(map((data: any) => {
                  console.log('retres-data', data);
                  return data.joblist;
                  
              }));
        }

        getinsjobposts(): Observable<any> {
          debugger
        
          return this.http.get(this.callurl + 'getinsjobposts/'+this.clcd+'/'+this.aycd+'/'+this.insid)
          .pipe(map((data: any) => {
                  console.log('retres-data', data);
                  return data.joblist;
                  
              }));
        }

        getapplied(jpid,insid): Observable<any> {
          debugger
        
          return this.http.get(this.callurl + 'getpostapplied/'+this.clcd+'/'+this.aycd+'/'+jpid+'/'+insid)
          .pipe(map((data: any) => {
                  console.log('retres-data', data);
                  return data.appliedlst;
                  
              }));
        }


        downloadappprofile(jpid,insid,stuid): Observable<any> {
          debugger
         var timeStamp = (new Date()).toISOString().replace(/[^0-9]/g, '').slice(0, -3);
          return this.http.get(this.callurl + 'downloadprofile/'+this.clcd+'/'+this.aycd+'/'+jpid+'/'+insid+'/'+stuid,{responseType: "blob"})
          .pipe(map((data: any) => {
            return {
              filename: 'Profile_'+timeStamp+'.zip',
              data: data
            };
                  
              }));
        }
        
        getpostoverview(): Observable<any> {
          debugger
        
          return this.http.get(this.callurl + 'placementoverview/'+this.clcd+'/'+this.aycd)
          .pipe(map((data: any) => {
                  console.log('retres-data', data);
                  return data;
                  
              }));
        }

        getinspostoverview(): Observable<any> {
          debugger
        
          return this.http.get(this.callurl + 'insjoboverview/'+this.clcd+'/'+this.aycd+'/'+this.insid)
          .pipe(map((data: any) => {
                  console.log('retres-data', data);
                  return data;
                  
              }));
        }

        getinsalloted(jpid): Observable<any> {
          debugger
        
          return this.http.get(this.callurl + 'getpostallotedins/'+jpid)
          .pipe(map((data: any) => {
                  console.log('retres-data', data);
                  return data.inslist;
                  
              }));
        }

        getinsallotedclass(jpid): Observable<any> {
          debugger
        
          return this.http.get(this.callurl + 'getpostallotedinsclass/'+jpid)
          .pipe(map((data: any) => {
                  console.log('retres-data', data);
                  return data.inslist;
                  
              }));
        }

        saveinsallotment(jpid,insid,oprtype,clid): Observable<any> {
          debugger
        
          return this.http.get(this.callurl + 'saveinsallotment/'+jpid+'/'+insid+'/'+oprtype+'/'+clid)
          .pipe(map((data: any) => {
                  console.log('retres-data', data);
                  return data;
                  
              }));
        }
        save_plajobpostingh(objpost): Observable<any> {
          debugger
          objpost.clcd=this.clcd;
          objpost.aycd=this.aycd;
          objpost.usid=this.usid;
          return this.http.post(this.callurl + 'save_plajobpostingh',objpost)
          .pipe(map((data: any) => {
                  console.log('retres-data', data);
                  return data;
                  
              }));
        }

        save_placompany(objpost): Observable<any> {
          debugger
          objpost.clcd=this.clcd;
          objpost.aycd=this.aycd;
          objpost.usid=this.usid;
          return this.http.post(this.callurl + 'save_placompany',objpost)
          .pipe(map((data: any) => {
                  console.log('retres-data', data);
                  return data;
                  
              }));
        }

        getschnotification() {
          let clcd=this.clcd;
          let aycd=this.aycd;
          var pstdata={clcd:this.clcd,aycd:this.aycd};
         // console.log('url',this._global.baseAPIUrl + 'sel_sp_schholidaylist/'+clcd+'/'+aycd);
          return this.http.post(this._global.baseAPIUrl + 'getnotifications',pstdata)
              .pipe(map((data: any) => {
                  return data.notelst;
              }));
          }

          getschnotd(nfid) {
              let clcd=this.clcd;
              let aycd=this.aycd;
              var pstdata={clcd:this.clcd,aycd:this.aycd,nfid:nfid};
             // console.log('url',this._global.baseAPIUrl + 'sel_sp_schholidaylist/'+clcd+'/'+aycd);
              return this.http.post(this._global.baseAPIUrl + 'getnoted',pstdata)
                  .pipe(map((data: any) => {
                      return data.notelst;
                  }));
              }

              saveschnotification(empdata: any): Observable<any> {
                // empdata.ayid='16';
                 empdata.usid=this.usid;
                 empdata.clcd=this.clcd;
                 empdata.aycd=this.aycd;
                 return this.http.post(this._global.baseAPIUrl + 'savenotification', empdata)
                     .pipe(map((data: any) => {
                         console.log('retres', data);
                         return data;
                     }));
             }

             uploadplatemplate(data: File,jpid,fnm): Observable<any> {
                                /// this._url = 'http://localhost:4200/XXXXXXXXXX/uploadFile';
                              debugger
                                const formData: FormData = new FormData();
                                //console.log("stuid",bkid)
                              
                                formData.append('Image', data, data.name);
                               
                                  formData.append('jpid', jpid);
                               
                                  formData.append('fnm', fnm);
                                  formData.append('clcd', this.clcd);
                                  formData.append('aycd', this.aycd);
                                  formData.append('crby', this.usid);
                                  console.log("formData",formData);
                                 return this.http.post(this._global.baseAPIUrl + 'uploadplatemplate', formData)
                                 .pipe(map((data: any) => {
                                     console.log('retres', data);
                                     return data
                                 }));
                              }


                                 gettempuploads(nfid) {
              let clcd=this.clcd;
              let aycd=this.aycd;
              var pstdata={clcd:this.clcd,aycd:this.aycd,jpid:nfid};
             // console.log('url',this._global.baseAPIUrl + 'sel_sp_schholidaylist/'+clcd+'/'+aycd);
              return this.http.post(this._global.baseAPIUrl + 'getplatemplates',pstdata)
                  .pipe(map((data: any) => {
                      return data.notelst;
                  }));
              }

              delplatemp(nfid) {
              let clcd=this.clcd;
              let aycd=this.aycd;
              var pstdata={clcd:this.clcd,aycd:this.aycd,rid:nfid};
             // console.log('url',this._global.baseAPIUrl + 'sel_sp_schholidaylist/'+clcd+'/'+aycd);
              return this.http.post(this._global.baseAPIUrl + 'delplatemp',pstdata)
                  .pipe(map((data: any) => {
                      return data;
                  }));
              }

            //    gettempuploads(nfid) {
            //   let clcd=this.clcd;
            //   let aycd=this.aycd;
            //   var pstdata={clcd:this.clcd,aycd:this.aycd,jpid:nfid};
            //  // console.log('url',this._global.baseAPIUrl + 'sel_sp_schholidaylist/'+clcd+'/'+aycd);
            //   return this.http.post(this._global.baseAPIUrl + 'getplatemplates',pstdata)
            //       .pipe(map((data: any) => {
            //           return data.notelst;
            //       }));
            //   }

              getplastudocs(nfid,stuid) {
              let clcd=this.clcd;
              let aycd=this.aycd;
              var pstdata={clcd:this.clcd,aycd:this.aycd,jpid:nfid,stuid:stuid};
             // console.log('url',this._global.baseAPIUrl + 'sel_sp_schholidaylist/'+clcd+'/'+aycd);
              return this.http.post(this._global.baseAPIUrl + 'getplacementdocs',pstdata)
                  .pipe(map((data: any) => {
                    console.log('retres', data);
                      return data.notelst;
                  }));
              }
}
